module.exports = __webpack_public_path__ + "health-systems-rightlogos-retina___19R3C.png";